/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { factorialDependencies } from './dependenciesFactorial.generated.js';
import { typedDependencies } from './dependenciesTyped.generated.js';
import { createPermutations } from '../../factoriesAny.js';
export var permutationsDependencies = {
  factorialDependencies,
  typedDependencies,
  createPermutations
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/mathjs/lib/esm/entry/dependenciesAny/dependenciesPermutations.generated.js
// module id = null
// module chunks = 